import { useEffect, useState } from "react";

const CustomerSegmentationTable = ({ rfmResponse, filterRfmResponse, subTabs,page,limit,total,setPage,segmentFilter,setSegmentFilter,searchQuery,setSearchQuery,sortBy,setSortBy }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
    // const [searchQuery, setSearchQuery] = useState('');
    const [recencyFilter, setRecencyFilter] = useState('');
    // const [segmentFilter, setSegmentFilter] = useState('');
    const [recencyComparison, setRecencyComparison] = useState('eq'); // 'eq' | 'lt' | 'gt'
    const [originalFilterData, setOriginalFilterData] = useState(filterRfmResponse)
    const [filterRfmResponseForSegment, setFilterRfmResponseForSegment] = useState([]);
    // const [sortBy,setSortBy] = useState('');
    


    // useEffect(() => {

    //     const filterResponse = filterRfmResponse
    //         // Text filter: matches name or email (case-insensitive)
    //         .filter((cust) => {
    //             if (!searchQuery) return true;
    //             const nameMatch = cust.name?.toLowerCase().includes(searchQuery.toLowerCase());
    //             const emailMatch = cust.email?.toLowerCase().includes(searchQuery.toLowerCase());
    //             return nameMatch || emailMatch;
    //         })

    //         .filter((cust) => {
    //             if (!segmentFilter) return true;

    //             return cust.segment === segmentFilter;
    //         })

    //         // Recency filter: exact match of days (optional)
    //         // .filter((cust) => {
    //         //     if (!recencyFilter) return true;
    //         //     const value = parseInt(recencyFilter);
    //         //     if (isNaN(value)) return true;
    //         //     switch (recencyComparison) {
    //         //         case 'lt':
    //         //             return cust.recency_days < value;
    //         //         case 'lte':
    //         //             return cust.recency_days <= value;
    //         //         case 'gt':
    //         //             return cust.recency_days > value;
    //         //         case 'gte':
    //         //             return cust.recency_days >= value;
    //         //         case 'ne':
    //         //             return cust.recency_days !== value;
    //         //         case 'eq':
    //         //         default:
    //         //             return cust.recency_days === value;
    //         //     }
    //         // })

    //         // Segment filter: match selected segment
            

    //         // .filter((cust)=>{
    //         //     if(!sortBy) return true;
    //         //     switch (recencyComparison) {
    //         //         case 'hp':
    //         //             return cust.totalSpent < value;
    //         //         case 'lp':
    //         //             return cust.totalSpent <= value;
    //         //         case 'hd':
    //         //             return cust.recency_days > value;
    //         //         case 'ld':
    //         //             return cust.recency_days >= value;
    //         //         default:
    //         //             return true;
    //         //     }
                
    //         // })

    //     setOriginalFilterData(filterResponse)
    //     setCurrentPage(1)
    // }, [recencyComparison, recencyFilter, searchQuery,segmentFilter])

    // useEffect(()=>{
    //     let sorted = [...originalFilterData];
    //     switch (sortBy) {
    //         case 'hp': // High Price → Sort by totalSpent descending
    //         sorted.sort((a, b) => b.total_spent - a.total_spent);
    //           break;
    //         case 'lp': // Low Price → Sort by totalSpent ascending
    //         sorted.sort((a, b) => a.total_spent - b.total_spent);
    //           break;
    //         case 'hd': // High Days → Sort by recency_days descending
    //         sorted.sort((a, b) => b.recency_days - a.recency_days);
    //           break;
    //         case 'ld': // Low Days → Sort by recency_days ascending
    //         sorted.sort((a, b) => a.recency_days - b.recency_days);
    //           break;
    //         default:
    //           break; // No sorting
    //       }

    //       setOriginalFilterData(sorted)

    // },[sortBy])

    // useEffect(() => {

    //     // const filterResponse = filterRfmResponse
    //     //     // Segment filter: match selected segment
    //     //     .filter((cust) => {
    //     //         // console.log(cust,"iiii","Loyalist")
    //     //         let segmentFilter =
    //     //             subTabs === "atRisk" ? "At Risk" :
    //     //                 subTabs === "champions" ? "Champion" :
    //     //                     subTabs === "potential" ? "Potential" :
    //     //                         subTabs === "hibernating" ? "Hibernating" :
    //     //                             subTabs === "others" ? "Others" :
    //     //                                 subTabs === "new" ? "New" :
    //     //                                     subTabs === "loyalists" ? "Loyalist" : "sds"

    //     //         // console.log(segmentFilter,cust.segment === segmentFilter,subTabs)

    //     //         return cust.segment === segmentFilter
    //     //     })
    //     setOriginalFilterData(filterRfmResponse)
    //     setCurrentPage(1)
    // }, [])


    const totalPages = Math.ceil(total / limit);

    // const paginatedData = originalFilterData.slice(
    //     (currentPage - 1) * itemsPerPage,
    //     currentPage * itemsPerPage
    // );

    return (
        <>
            <div className="fade-in  p-6 mb-0 cstm_ResultsTest-radius rounded-none">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 ">
                    {/* Search Input */}
                    <input
                        type="text"
                        placeholder="Search by name, email"
                        value={searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value)
                            setPage(1)
                        }}
                        className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                    />

                    {/* Number Input for Recency Days */}
                    {/* <div className="flex md:grid-cols-4 gap-4"> */}


                        {/* Number Input */}
                        {/* <input
                            type="number"
                            placeholder="Recency days"
                            value={recencyFilter}
                            onChange={(e) => setRecencyFilter(e.target.value)}
                            className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                        /> */}

                        {/* Comparison Dropdown */}
                        {/* <select
                            value={recencyComparison}
                            onChange={(e) => setRecencyComparison(e.target.value)}
                            className="px-2 py-2 border border-gray-300 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                            <option value="eq">= Equal to</option>
                            <option value="ne">≠ Not equal to</option>
                            <option value="lt">&lt; Less than</option>
                            <option value="lte">≤ Less than or equal</option>
                            <option value="gt">&gt; Greater than</option>
                            <option value="gte">≥ Greater than or equal</option>
                        </select> */}
                    {/* </div> */}

                    {/* Dropdown for Segment Filter */}
                    <select
                        value={segmentFilter}
                        onChange={(e) => {
                            setSegmentFilter(e.target.value)
                            setPage(1)
                        }}
                        className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                    >
                        <option value="">All Segments</option>
                        <option value="Champion">Champions</option>
                        <option value="Loyalist">Loyalists</option>
                        <option value="Potential">Potential</option>
                        <option value="New">New</option>
                        <option value="At Risk">At Risk</option>
                        <option value="Hibernating">Hibernating</option>
                        <option value="Others">Others</option>
                    </select>
                    <select
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                    >
                        <option value="">Sort By</option>
                        <option value="hp">Highest Spent</option>
                        <option value="lp">Lowest Spent</option>
                        <option value="hd">Highest Days</option>
                        <option value="ld">Lowest Days</option>
                    </select>
                </div>
                <br />
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                {['Customer', 'RFM Score', 'Details'].map(header => (
                                    <th
                                        key={header}
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className=" divide-y divide-gray-200">
                            {originalFilterData.length > 0 && originalFilterData.map((cust, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="flex items-center">
                                            <div
                                                className={`flex-shrink-0 h-10 w-10 bg-${cust.color}-100 rounded-full flex items-center justify-center`}
                                            >
                                                <span className={`text-${cust.color}-800 font-bold`}>{cust.initials}</span>
                                            </div>
                                            <div className="ml-4">

                                                <div className="text-sm font-medium text-gray-900">{cust.name?.trim() == "" ? 'N/A' : cust.name}</div>
                                                <div className="text-sm text-gray-500">{cust.email?.trim() == null ? "N/A" : cust.email}</div>
                                                <span
                                            className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-${cust.segmentColor}-100 text-${cust.segmentColor}-800`}
                                        >
                                            {cust.segment}
                                        </span>
                                            </div>
                                        </div>
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap ">
                                        <div className="flex  mb-1">
                                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mr-1">
                                                R{cust?.scores?.R}
                                            </span>
                                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mr-1">
                                                F{cust?.scores?.F}
                                            </span>
                                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                                M{cust?.scores?.M}
                                            </span>
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            Total: {cust.scores?.R + cust.scores?.F + cust.scores?.M} (R+F+M)
                                        </div>
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-gray-900">Recency: {cust.recency}</div>
                                        <div className="text-sm text-gray-500">
                                            Total Spent: {cust.totalSpent} | Orders: {cust.orders}
                                        </div>
                                    </td>


                                </tr>
                            ))}
                            {originalFilterData.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="px-6 py-10 text-center">
                                        <div className="flex items-center justify-center">
                                            <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-gray-100 text-gray-500">
                                                No Record Found!
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {
                        totalPages > 1 && originalFilterData.length >0 &&
                        <div className="flex justify-between items-center mt-6 px-6">
                            <div className="text-sm text-gray-600">
                                Page <span className="font-medium text-gray-800">{page}</span> of <span className="font-medium text-gray-800">{totalPages}</span>
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                                    disabled={page === 1}
                                    className={`px-4 py-2 rounded-md text-sm font-medium ${page === 1
                                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                            : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300 shadow-sm'
                                        }`}
                                >
                                    Previous
                                </button>
                                <button
                                    onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                                    disabled={page === totalPages}
                                    className={`px-4 py-2 rounded-md text-sm font-medium ${page === totalPages
                                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                            : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300 shadow-sm'
                                        }`}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default CustomerSegmentationTable;